import { render, staticRenderFns } from "./PanelMyAccount.vue?vue&type=template&id=109d9823"
import script from "./PanelMyAccount.vue?vue&type=script&lang=js"
export * from "./PanelMyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports